export const GET_ALTRI_INSTRADAMENTO_DATA_AND_LOADING =
  "GET_ALTRI_INSTRADAMENTO_DATA_AND_LOADING";
export const EXPORT_ALTRI_INSTRADAMENTO_LOADING =
  "EXPORT_ALTRI_INSTRADAMENTO_LOADING";
export const CREATE_UPDATE_DELETE_PIANI_DI_INSTRADAMENTO_LOADING =
  "CREATE_UPDATE_DELETE_PIANI_DI_INSTRADAMENTO_LOADING";
export const GET_CREATE_MENU_SERVICE_DATA = "GET_CREATE_MENU_SERVICE_DATA";
export const GET_CURRENT_MENU_SERVICE = "GET_CURRENT_MENU_SERVICE";
export const GET_CREATE_ORIGINE_DATA = "GET_CREATE_ORIGINE_DATA";
export const GET_CURRENT_ORIGINE = "GET_CURRENT_ORIGINE";
export const GET_CREATE_TEMPO_DATA = "GET_CREATE_TEMPO_DATA";
export const GET_CURRENT_TEMPO = "GET_CURRENT_TEMPO";
export const TEMPO_AGGIUNGI_CLICK = "TEMPO_AGGIUNGI_CLICK";
